import {
  ROLE_SUPER_ADMIN,
  ROLE_ADMIN,
  ROLE_BUSINESS_ADMIN,
  ROLE_MARKETING_ADMIN,
  ROLE_FINANCE_ADMIN,
  ROLE_BUSINESS_SMOOTHPAY,
  ROLE_OPERATOR,
  ROLE_LOYALTY_ADMIN,
} from './rolesRepository';

export default {
  toppers: [
    ROLE_ADMIN,
    ROLE_BUSINESS_ADMIN,
    ROLE_MARKETING_ADMIN,
    ROLE_FINANCE_ADMIN,
  ],
  sodexo: [
    ROLE_ADMIN,
    ROLE_BUSINESS_ADMIN,
    ROLE_MARKETING_ADMIN,
    ROLE_FINANCE_ADMIN,
  ],
  default: [
    ROLE_ADMIN,
    ROLE_BUSINESS_ADMIN,
    ROLE_MARKETING_ADMIN,
    ROLE_FINANCE_ADMIN,
    ROLE_LOYALTY_ADMIN,
  ],
};
